import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { images } from '../../constants';
import { services, serviceCardLayout } from '../../data';
import './services.scss';

const ServiceCard = ({ image, title, onClick }) => {
  return (
    <button className="service__card" onClick={onClick}>
      <img className="service__icon" src={image} alt={title} />
      <img className="service__blur" src={images.bgBlur} alt="" />
      <h2>{title}</h2>
    </button>
  );
};

const Services = () => {
  const { t } = useTranslation();
  const [selectedService, setSelectedService] = useState(services[0]);

  const handleServiceChange = (serviceId) => {
    const selected = services.find(service => service.id === serviceId);
    setSelectedService(selected);
  };

  return (
    <section className="services container">
      <div>
        <h1>{t('services.title')}</h1>
        <p>{t('services.subtitle')}</p>
      </div>
      <div className="services__collection-center ">
        <div className="VidIcons">
          <video src={images[selectedService.videoKey]} autoPlay loop muted />
          <img className="VidIcons__blur" src={images.bgBlur} alt="" />
        </div>
        <div className="CardInfo">
          <h2>{t(`data.services.${selectedService.id}.title`)}</h2>
          <p>{t(`data.services.${selectedService.id}.desc`)}</p>
        </div>
        <img className="services__pedestal" src={images.pedestal} alt="" />
      </div>
      <div className="services__collection ">
        <div className="services__collection-left ">
          {serviceCardLayout.left.map((card) => (
            <ServiceCard
              key={card.id}
              image={images[card.iconKey]}
              title={t(`data.services.${card.id}.title`)}
              onClick={() => handleServiceChange(card.id)}
            />
          ))}
        </div>
        <div className="services__collection-right ">
          {serviceCardLayout.right.map((card) => (
            <ServiceCard
              key={card.id}
              image={images[card.iconKey]}
              title={t(`data.services.${card.id}.title`)}
              onClick={() => handleServiceChange(card.id)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
    


export default Services;
